<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
    <AlertBar></AlertBar>
  </v-app>
</template>

<script>
import Home from './components/Home';
import Globe from './components/globe/Globe';
import Africa from './components/africa/Dashboard';
import AlertBar from './components/AlertBar';

export default {
  name: 'App',
  components: {
    Home,
    Globe,
    Africa,
    AlertBar
  },
  data: () => ({
  }),
};
</script>

<style>
.scrollList {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(29, 29, 29, 0.6);
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(29, 29, 29, 0.4);
}

.scroll-light::-webkit-scrollbar-thumb {
  background-color: rgba(101, 101, 101, 0.6);
}

.scroll-light::-webkit-scrollbar-thumb:hover {
  background-color: rgba(101, 101, 101, 0.4);
}
</style>
